import { render, staticRenderFns } from "./ImportDownload.vue?vue&type=template&id=241803d3&scoped=true"
import script from "./ImportDownload.vue?vue&type=script&lang=js"
export * from "./ImportDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241803d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241803d3')) {
      api.createRecord('241803d3', component.options)
    } else {
      api.reload('241803d3', component.options)
    }
    module.hot.accept("./ImportDownload.vue?vue&type=template&id=241803d3&scoped=true", function () {
      api.rerender('241803d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/partition/cmp/ImportDownload.vue"
export default component.exports